import type { OssApi } from './types'

import { fundRequestClient, requestClient } from '#/api/request'

import { defineApi } from '../../define-api'

export const ossApi = defineApi('common/oss', ({ prefix }) => {
  function getUploadToken(filetype: Numeric) {
    return requestClient.get<OssApi.GetUploadTokenResponse>(prefix('sts'), {
      params: {
        file_type: filetype,
      },
    })
  }

  function getOperationUploadToken(fileName: string) {
    return requestClient.get<OssApi.GetOperationUploadTokenResponse>(
      'operation/file/token',
      {
        params: {
          fileName,
        },
      },
    )
  }

  function getFileUrl(params: { filename: string; filetype: Numeric }) {
    return requestClient.get(prefix('sign_url'), {
      params: {
        filename: params.filename,
        file_type: params.filetype,
      },
    })
  }

  /**
   * 上传资金服务文件。
   * POST /oss/upload
   */
  function uploadFundFile(file: File) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('feishu_approval', '1')

    return fundRequestClient
      .post<OssApi.UploadFundFileResponse>('oss/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 1000 * 60 * 10,
      })
      .then((res) => ({
        fileKey: res.file_key,
        id: res.id,
        url: res.url,
      }))
  }

  return {
    getUploadToken,
    getOperationUploadToken,
    getFileUrl,
    uploadFundFile,
  }
})
